import { render, staticRenderFns } from "./CostCentreMenu.vue?vue&type=template&id=2b5c269c&scoped=true&"
import script from "./CostCentreMenu.vue?vue&type=script&lang=js&"
export * from "./CostCentreMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c269c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b5c269c')) {
      api.createRecord('2b5c269c', component.options)
    } else {
      api.reload('2b5c269c', component.options)
    }
    module.hot.accept("./CostCentreMenu.vue?vue&type=template&id=2b5c269c&scoped=true&", function () {
      api.rerender('2b5c269c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/CostCentre/CostCentreMenu.vue"
export default component.exports